module.exports = __webpack_public_path__ + "static/media/coreproduct.9dfe477a.png";